import { Component, OnInit } from '@angular/core';
import { AppContextService } from '../../services/app-context.service';
import { User } from '../../models/User/user';
import { TranslateService } from '../../services/translate/translate.service';

@Component({
	selector: 'app-private-home',
	templateUrl: './private-home.component.html',
	styleUrls: ['./private-home.component.scss'],
	standalone: false,
})
export class PrivateHomeComponent implements OnInit {
	public loggedUser: User | null = new User();
	public newFeatureHtml: string | null = null;

	constructor(
		private appContext: AppContextService,
		private translateService: TranslateService
	) {}

	ngOnInit() {
		this.loggedUser = this.appContext.getLoggedUser() ?? new User();

		this.newFeatureHtml = this.getNewFeatureDocumentHtmlLink();
	}

	private getNewFeatureDocumentHtmlLink(): string | null {
		let link = this.translateService.translateByLanguage('home.newfeatures.document', this.loggedUser?.LanguageCode, 'client');

		if (!link) return null;

		let downloadFileName = this.translateService.translateByLanguage(
			'home.newfeatures.documentName',
			this.loggedUser?.LanguageCode,
			'client'
		);
		let ticks = new Date().getTime() * 10000 + 621355968000000000;

		return link.replace('[BypassCacheStrategy]', ticks.toString()).replace('[DownloadFilename]', downloadFileName);
	}
}
